import {get, set} from "./schedule";

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

export default function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get(this.node(), id).ease;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-transition/src/transition/ease.js
// module id = 1888
// module chunks = 3